import { isDiversionValid } from "../../../SystemSettingsStagingDiversion/SystemSettingsStagingDiversion.utils";
import { ROLE_ARN_PATTERN } from "./EmrStagingIntegrationForm.constants";
import {
  type EmrStagingEntry,
  emrStagingSchema,
} from "./EmrStagingIntegrationForm.types";

export function emptyEmrStaging(): EmrStagingEntry {
  return emrStagingSchema.parse({});
}

export function isRoleArn(value: string) {
  return ROLE_ARN_PATTERN.test(value.trim());
}

export function canSaveEmr(entry: EmrStagingEntry) {
  return isRoleArn(entry.runner_role_arn) && isDiversionValid(entry, "s3://");
}
